angular.module('bmsApp.ticket')
	.factory('TicketTypesSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

			function options(params) {
				return CRUDSvc.get('api/ticket/types/options', params);
			}

			return {
				options: options
			}

		}
	]);
